import React, { useEffect, useState } from "react"


export const ImageSlideshow = ({ images, interval = 5000 }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const timer = setTimeout(() => {
            const nextIndex = currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1;
            setCurrentImageIndex(nextIndex);
        }, interval);

        return () => clearTimeout(timer);
    }, [currentImageIndex, images.length, interval]);

    return (
        <div className="image-slideshow-container">

            {images.map((image, index) => (
                <div
                    className="image-slide"
                    key={index}
                    style={{
                        backgroundImage: `url(${image})`,
                        opacity: index === currentImageIndex ? 1 : 0,
                        transition: 'opacity 1s ease-in-out',
                        minHeight: index === currentImageIndex ? '100%' : '0px',
                    }}
                ></div>
            ))}
        </div>
    )
}